
import { getN19ImportTable } from "./importstln19table";
import { configurations_getDefaultParams } from "../../../../utils/configurations";
import { V2_FormatTimeCodeString,V2_ConvertTimeCodeStringToSecond } from "../../../../utils/timecodev2";
import { removeEmptyLines } from "../subtitles/common/functions";

function STL_GetUTF8String(buffer, start,len)
{
    const subView = new Uint8Array(buffer, start,len);
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(subView).trim();    
}


function colorcode_to_stl_string (colorcode)
{
    switch (colorcode)
    {
        case 0: return "black";
        case 1: return "red";
        case 2: return "green";
        case 3: return "yellow";
        case 4: return "blue";
        case 5: return "magenta";
        case 6: return "cyan";
        case 7: return "white";
    }
    return "white";
}

function colorcodeToHex(color)
{
    switch (color)
    {
        case 0: return "#000000"
        case 4: return "#0000FF";
        case 2: return "#00FF00";
        case 6: return "#00FFFF";
        case 1: return "#FF0000";
        case 5: return "#FF00FF";
        case 3: return "#FFFF00";
    }
    return "#FFFFFF"
}

function colorcode_to_ttml_string (colorcode)
{
    switch (colorcode)
    {
        case 0: return "black";
        case 1: return "soundIndication";
        case 2: return "foreignLanguage";
        case 3: return "offScreen";
        case 4: return "other";
        case 5: return "music";
        case 6: return "voiceOver";
        case 7: return "onScreen";
    }
    return "onScreen";
}

/*
typedef struct
{
	unsigned short	UNICODECHAR; // code unicode
	BYTE			C1;  // code dans la table n19
	BYTE			C2;  // C2 <> 0 Caractères composés (accentués)
	BYTE			Table; // 00..04 ou 0xFF si toutes tables
	BYTE			CodeLangue; // code language ou 0xFF si tout languages
} N19CHAR;
 */

function N19ConvertByteToUnicode(N19Table, N19Char ,CodeCaractere,LanguageCode,CodeEx)
{
	var Found = false;
	var EndOfTable = false;
	var CharFound = 0x0020;
	var pTable=0;

    

    const UNICODECHAR = 0;
    const C1 = 1;
    const C2 = 2;
    const Table = 3;
    const CodeLangue = 4;

	while ((!Found) && (!EndOfTable))
	{
		if (N19Table[pTable][UNICODECHAR] == 0xFFFF)
			EndOfTable = true;
		else
		{
			if ((N19Table[pTable][C1]  == N19Char) && (N19Table[pTable][C2] == CodeEx))
			{
				// Un espoir

				var OkTable=false;
				var OkLangue = false;
				if (N19Table[pTable][Table] == 0xFF) 
					OkTable=true;
				else
				{
					if (N19Table[pTable][Table] == CodeCaractere) 
						OkTable=true;
				}
				if (N19Table[pTable][CodeLangue] == 0xFF)
					OkLangue=true;
				else
				{
					if (N19Table[pTable][CodeLangue] == LanguageCode)
						OkLangue=true;
				}
				
				if ((OkLangue) && (OkTable))
				{
					CharFound = N19Table[pTable][UNICODECHAR];
					Found=true;
				}
			}
			pTable++;
		}
	}
	return CharFound;
}



// Fonction pour décoder une portion d’ArrayBuffer en CP850
function STL_GetUTF8StringFromcp850(buffer, start, len) 
{

// Table CP850 complète : index = byte (0–255), valeur = caractère Unicode
    const cp850Table = new Uint16Array([
    0x0000,0x0001,0x0002,0x0003,0x0004,0x0005,0x0006,0x0007,
    0x0008,0x0009,0x000A,0x000B,0x000C,0x000D,0x000E,0x000F,
    0x0010,0x0011,0x0012,0x0013,0x0014,0x0015,0x0016,0x0017,
    0x0018,0x0019,0x001A,0x001B,0x001C,0x001D,0x001E,0x001F,
    0x0020,0x0021,0x0022,0x0023,0x0024,0x0025,0x0026,0x0027,
    0x0028,0x0029,0x002A,0x002B,0x002C,0x002D,0x002E,0x002F,
    0x0030,0x0031,0x0032,0x0033,0x0034,0x0035,0x0036,0x0037,
    0x0038,0x0039,0x003A,0x003B,0x003C,0x003D,0x003E,0x003F,
    0x0040,0x0041,0x0042,0x0043,0x0044,0x0045,0x0046,0x0047,
    0x0048,0x0049,0x004A,0x004B,0x004C,0x004D,0x004E,0x004F,
    0x0050,0x0051,0x0052,0x0053,0x0054,0x0055,0x0056,0x0057,
    0x0058,0x0059,0x005A,0x005B,0x005C,0x005D,0x005E,0x005F,
    0x0060,0x0061,0x0062,0x0063,0x0064,0x0065,0x0066,0x0067,
    0x0068,0x0069,0x006A,0x006B,0x006C,0x006D,0x006E,0x006F,
    0x0070,0x0071,0x0072,0x0073,0x0074,0x0075,0x0076,0x0077,
    0x0078,0x0079,0x007A,0x007B,0x007C,0x007D,0x007E,0x007F,
    0x00C7,0x00FC,0x00E9,0x00E2,0x00E4,0x00E0,0x00E5,0x00E7,
    0x00EA,0x00EB,0x00E8,0x00EF,0x00EE,0x00EC,0x00C4,0x00C5,
    0x00C9,0x00E6,0x00C6,0x00F4,0x00F6,0x00F2,0x00FB,0x00F9,
    0x00FF,0x00D6,0x00DC,0x00A2,0x00A3,0x00A5,0x20A7,0x0192,
    0x00E1,0x00ED,0x00F3,0x00FA,0x00F1,0x00D1,0x00AA,0x00BA,
    0x00BF,0x2310,0x00AC,0x00BD,0x00BC,0x00A1,0x00AB,0x00BB,
    0x2591,0x2592,0x2593,0x2502,0x2524,0x00C1,0x00C2,0x00C0,
    0x00A9,0x2563,0x2551,0x2557,0x255D,0x00A2,0x00A5,0x2510,
    0x2514,0x2534,0x252C,0x251C,0x2500,0x253C,0x00E3,0x00C3,
    0x255A,0x2554,0x2569,0x2566,0x2560,0x2550,0x256C,0x00A4,
    0x00F0,0x00D0,0x00CA,0x00CB,0x00C8,0x0131,0x00CD,0x00CE,
    0x00CF,0x2518,0x250C,0x2588,0x2584,0x00A6,0x00CC,0x2580,
    0x00D3,0x00DF,0x00D4,0x00D2,0x00F5,0x00D5,0x00B5,0x00FE,
    0x00DE,0x00DA,0x00DB,0x00D9,0x00FD,0x00DD,0x00AF,0x00B4,
    0x00AD,0x00B1,0x2017,0x00BE,0x00B6,0x00A7,0x00F7,0x00B8,
    0x00B0,0x00A8,0x00B7,0x00B9,0x00B3,0x00B2,0x25A0,0x00A0
    ]);
    

    const subView = new Uint8Array(buffer, start,len);
    
    // Étape 1 : décoder CP850 → chaîne Unicode JS
    var decoded = new Uint16Array(subView.length);
    for (let i = 0; i < subView.length; i++) {
        decoded[i] =  cp850Table[subView[i]];
    }

    

    const decoder = new TextDecoder("utf-16");
    return decoder.decode(decoded).trim();    
}

function UnicodeArrayToText(unicode)
{
    const uint16Arr = new Uint16Array(unicode);
    const decoder = new TextDecoder("utf-16");
    return decoder.decode(uint16Arr).trim();    

}

function concatUint8Arrays(a, b) {
    const result = new Uint8Array(a.length + b.length);

    result.set(a, 0);
    result.set(b, a.length);

    return result;
}

export function convertEBUDatasToSTL (binarystldatas)
{
    var jsonstl =
    {
        success: false,

    }

    

    const filesize = binarystldatas.byteLength;

    if (filesize < 1024) return jsonstl;

    const nbtti = parseInt(STL_GetUTF8String(binarystldatas,238,5));
    const nbst = parseInt(STL_GetUTF8String(binarystldatas,243,5));

    


    if (filesize != (nbtti * 128 + 1024))
    {
        jsonstl["errorlib"] = "Incorrect expected file size";
        return jsonstl;
    }

    const stlframerate = parseInt(STL_GetUTF8String(binarystldatas,6,2));
    jsonstl.framerate = stlframerate;
    jsonstl.dropframe = 0;

    jsonstl.num = 25;
    jsonstl.den = 1;
    switch (stlframerate)
    {
        case 25:
            jsonstl.num = 25;
            jsonstl.den = 1;
            break;
        case 23:
            jsonstl.num = 24000;
            jsonstl.den = 1001;
            break;
        case 24:
            jsonstl.num = 24;
            jsonstl.den = 1;
            break;
        case 29:
            jsonstl.num = 30;
            jsonstl.den = 1001;
            break;
        case 30:
            jsonstl.num = 30;
            jsonstl.den = 1;
            break;
    }

    jsonstl.nbtti = nbtti;
    jsonstl.nbst = nbst;

    jsonstl.titlepgm = STL_GetUTF8StringFromcp850 (binarystldatas, 16,32);
    jsonstl.titlepgmtrad = STL_GetUTF8StringFromcp850 (binarystldatas, 48,32);
    jsonstl.titleepi = STL_GetUTF8StringFromcp850 (binarystldatas, 80,32);
    jsonstl.titleepitrad = STL_GetUTF8StringFromcp850 (binarystldatas, 112,32);
    jsonstl.codepage = STL_GetUTF8String (binarystldatas, 0, 3);
    jsonstl.diskformat = STL_GetUTF8String (binarystldatas, 3, 8);
    jsonstl.displaystandardcode = STL_GetUTF8String (binarystldatas, 11, 1);
    jsonstl.translatorname = STL_GetUTF8StringFromcp850 (binarystldatas, 144,32);
    jsonstl.translatorcontact = STL_GetUTF8StringFromcp850 (binarystldatas, 176,32);
    jsonstl.listreferencecode = STL_GetUTF8StringFromcp850 (binarystldatas, 208,16);
    jsonstl.createdate = STL_GetUTF8String (binarystldatas, 224, 6);
    jsonstl.revisiondate = STL_GetUTF8String (binarystldatas, 230, 6);
    jsonstl.revisionnumber = STL_GetUTF8String (binarystldatas, 236, 2);
    jsonstl.maximumcharrow = parseInt(STL_GetUTF8String (binarystldatas, 251, 2));
    jsonstl.maximumrow = parseInt(STL_GetUTF8String (binarystldatas, 253, 2));
    if (!jsonstl.maximumrow ) jsonstl.maximumrow= 40;
    jsonstl.timecodestatus = STL_GetUTF8String (binarystldatas, 255, 1);
    jsonstl.tcstart = STL_GetUTF8String (binarystldatas, 256, 8);
    jsonstl.tcfirst = STL_GetUTF8String (binarystldatas, 264, 8);

    jsonstl.disksequence = STL_GetUTF8String (binarystldatas, 273, 1);
    jsonstl.countryoforigin = STL_GetUTF8String (binarystldatas, 274, 3);
    
    jsonstl.publisher = STL_GetUTF8StringFromcp850 (binarystldatas, 277,32);
    jsonstl.editor = STL_GetUTF8StringFromcp850 (binarystldatas, 309,32);
    jsonstl.editorcontact = STL_GetUTF8StringFromcp850 (binarystldatas, 341,32);

    jsonstl.subtitles = [];
    var n19table = getN19ImportTable();
    n19table = n19table.map(subArray => 
        new Uint16Array(
            subArray.map(item => typeof item === 'string' ? item.charCodeAt(0) : item)
        )
    );    

    var n=0;
    
    for (var tti = 0; tti < nbtti; tti++)
    {


        
        // on recherche la taille de ttybuffer

        
        var ttibuffersize = 0;

        var ttibuffer = new Uint8Array(binarystldatas, 1024 + tti * 128 , 128);      


        var totalbuffer = ttibuffer.slice(0);
        var ttibuffersize = 128;
        var subtitle = {};

        console.log("Test si c'est du fab",ttibuffer[16],ttibuffer[17],ttibuffer[18],ttibuffer[19],ttibuffer[20])
        // on regarde si c'est du fab
        if ( 
            (ttibuffer[16] == 70) &&
            (ttibuffer[17] == 65) &&
            (ttibuffer[18] == 66) &&
            (ttibuffer[19] == 115) &&
            (ttibuffer[20] == 116) // FABst
        )
        {
            // on prend que les 16 premiers dans ce cas
            totalbuffer = ttibuffer.slice(0, 16);
            ttibuffersize = 16;

            console.log("c'est du fab on prend que les 16 premiers")
        }



        if ((totalbuffer[15] === 0x00) && (totalbuffer[4] === 0x00))// comment flag + cumulatif
        {


            // on recherche si c'est cumulatif
            var nbttiforsubtitle = 1;


            while (ttibuffer[3] !== 0xFF)
            {

                tti = tti + 1
                ttibuffer = new Uint8Array(binarystldatas, 1024 + tti * 128 , 128);      
                // on ne prend pas la suite qui commence par FABst

                if ( 
                    (ttibuffer[16] != 70) ||
                    (ttibuffer[17] != 65) ||
                    (ttibuffer[18] != 66) ||
                    (ttibuffer[19] != 115) ||
                    (ttibuffer[20] != 116)
                )
                {
                    // on recuperer à partir du 16eme
                    var ttibuffercut = ttibuffer.slice(16);
                    totalbuffer = concatUint8Arrays(totalbuffer,ttibuffercut);
                    ttibuffersize = ttibuffersize + 128 - 16;
                    nbttiforsubtitle++;

                }


            }

            console.log("tti buffer size", ttibuffersize,"nbtti", nbttiforsubtitle)

            if (ttibuffersize) 
            {

                ttibuffer = totalbuffer;
                subtitle.number = ++n;

                var hh0 = ttibuffer[5];
                var mm0 = ttibuffer[6];
                var ss0 = ttibuffer[7];
                var ii0 = ttibuffer[8];

                var hh1 = ttibuffer[9];
                var mm1 = ttibuffer[10];
                var ss1 = ttibuffer[11];
                var ii1 = ttibuffer[12];

                subtitle.tcin = V2_FormatTimeCodeString(hh0,mm0,ss0,ii0);
                subtitle.tcout = V2_FormatTimeCodeString(hh1,mm1,ss1,ii1);
                subtitle.in = V2_ConvertTimeCodeStringToSecond(subtitle.tcin, jsonstl.num,jsonstl.den,0);
                subtitle.out = V2_ConvertTimeCodeStringToSecond(subtitle.tcout, jsonstl.num,jsonstl.den,0);

                var startvp = ttibuffer[13];

                var justification = "center";
                switch (ttibuffer[14])
                {
                    case 0: justification = "unchanged"; break;
                    case 1: justification = "left"; break;
                    case 2: justification = "center"; break;
                    case 3: justification = "right"; break;

                }


                subtitle["start_vertical_position"] = startvp;
                subtitle["justification"] = justification;
                


                subtitle.lines = [];
                var nblines = 0;
                var horizontalPos = 0;


                var text = [];
                var colorcode = 7;
                var dbheight = false;
                var italic = false;
                var verticalpos = startvp;
                var p = 16;

                /*
                if (
                    (ttibuffer[p] == 'F') &&
                    (ttibuffer[p] == 'A') &&
                    (ttibuffer[p] == 'B') &&
                    (ttibuffer[p] == 's') &&
                    (ttibuffer[p] == 'T')

                )   
                */

                

                
                while (p < ttibuffersize)
                {

                    if (ttibuffer[p] == 0x8F)
                        p=ttibuffersize;
                    else
                    {
                        if (ttibuffer[p]< 0x20)
                        {
                            // teletexte control codes
                            switch (ttibuffer[p])
                            {
                                case 0x0d:  
                                    horizontalPos++;
                                    dbheight=true; 
                                    break;
                                case 0x0b:
                                    horizontalPos++;
                                    break;

                                case 0:
                                    break;
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                    horizontalPos++;
                                    colorcode = ttibuffer[p]; break;
                                    break;
                            }
                        }
                        else
                        {
                            if ((ttibuffer[p] >=0x80) && (ttibuffer[p] <0x90))
                            {
                                // text control code
                                switch (ttibuffer[p])
                                {
                                    case 0x80:
                                        italic=true;
                                        if (text.length===0)  horizontalPos++;
                                        break;
                                    case 0x8A:
                                        if (text.length!=0)
                                        {
                                            var line = {};
                                            line["text"] = UnicodeArrayToText(text);
                                            line["vertical_position"] = verticalpos;
                                            line["italic"] = italic;
                                            line["horizontal_position"] = 0;
                                            if (justification === "unchanged")
                                            {
                                                line["horizontal_position"] = Math.floor ( (horizontalPos * 100) / jsonstl.maximumcharrow);
                                            }
                                            line["alignment"] = justification;
                                            line["color_code"] = colorcode;
                                            line["double_height"] = dbheight;
                                            line["color_text_stl"] = colorcode_to_stl_string(colorcode);
                                            line["color_text_indication"] = colorcode_to_ttml_string(colorcode);
                                            subtitle.lines.push(line)
                                            nblines++;
                                        }
                                        verticalpos++;
                                            
                                        text = [];
                                        horizontalPos = 0;
                                        colorcode = 7;
                                        dbheight = false;
                                        break;
                                        
                                }
                            }
                            else
                            {
                                // du texte

                                var c1= ttibuffer[p];
                                var c2=0x00;

                                if (((c1 & 0xF0) == 0xC0) && (p != 127))
                                {
                                    p++;
                                    c2 = ttibuffer[p];
                                }

                                var ca =  N19ConvertByteToUnicode(n19table, c1,0x00,0xFF,c2);

                                if (text.length === 0)
                                {
                                    if (ca != 0x0020) 
                                        text.push(ca);
                                    else
                                        horizontalPos++;
                                }
                                else
                                    text.push(ca);
                            }
                        }
                        p++;
                    }

                }


                if (text.length!=0)
                {
                    var line = {};
                    line["text"] = UnicodeArrayToText(text);
                    line["vertical_position"] = verticalpos;
                    line["horizontal_position"] = 0;
                    if (justification === "unchanged")
                    {
                        line["horizontal_position"] = Math.floor ( (horizontalPos * 100) / jsonstl.maximumcharrow);
                    }
                    line["italic"] = italic;
                    line["alignment"] = justification;
                    line["color_code"] = colorcode;
                    line["color_text_stl"] = colorcode_to_stl_string(colorcode);
                    line["color_text_indication"] = colorcode_to_ttml_string(colorcode);
                    line["double_height"] = dbheight;

                    subtitle.lines.push(line);
                    nblines++;
                }
                subtitle["number_of_lines"] = nblines;



                jsonstl.subtitles.push (subtitle);
            }
        }
    }

    jsonstl.success = true;
    return jsonstl;
}


function srtToJson(srt) {
    const subtitles = [];

    // Séparer les blocs de sous-titres
    const blocks = srt.trim().split(/\r?\n\s*\r?\n/);

    for (const block of blocks) {
        const lines = block.split(/\r?\n/);

        // Ligne 1 : numéro du sous-titre
        // Ligne 2 : timecode
        const timecode = lines[1]?.match(
            /(\d{2}):(\d{2}):(\d{2})[,.](\d{3})\s*-->\s*(\d{2}):(\d{2}):(\d{2})[,.](\d{3})/
        );

        if (!timecode) continue;

        // Convertir HH:MM:SS,mmm en secondes
        const toSeconds = (h, m, s, ms) =>
            Number(h) * 3600 +
            Number(m) * 60 +
            Number(s) +
            Number(ms) / 1000;

        const inTime = toSeconds(
            timecode[1], timecode[2],
            timecode[3], timecode[4]
        );

        const outTime = toSeconds(
            timecode[5], timecode[6],
            timecode[7], timecode[8]
        );

        // Toutes les lignes après le timecode
        const textLines = lines.slice(2)
            .filter(line => line.trim() !== "");

        subtitles.push({
            in: inTime,
            out: outTime,
            lines: textLines
        });
    }

    return { subtitles };
}

export function convertSRTtoOttoSubtitles(srtdatas)
{
    var ottosubtitles = {};
    ottosubtitles.subtitles = [];
    ottosubtitles.params = configurations_getDefaultParams();

    ottosubtitles.params.teletext = false;

    const srtSubtitles = srtToJson(srtdatas);

    ottosubtitles.subtitles = [];
    ottosubtitles.speakers = [];
    


    console.log(srtSubtitles)

    srtSubtitles.subtitles.forEach ((srtst,index) =>{
        var subtitle = {
            in: srtst.in,
            out: srtst.out,
            lines:[],
            len:0,
        }

        srtst.lines.forEach(phrase =>{
            var line = {};
            line.words = [];
            line.align = 2;
            line.doubleHeight = false;
            line.len = phrase.length;
            subtitle.len = subtitle.len + phrase.length;


            const words = phrase.trim().split(" ");
            for (var w=0; w < words.length;w++)
            {
                var word={};
                word.text = words[w];
                word.in = subtitle.in;
                word.out = subtitle.in;
                word.color = "#FFFFFF";
                word.italic = false;
                line.words.push(word);
            }
            subtitle.lines.push(line);

        })

        var starty = 22 - 2 * (subtitle.lines.length - 1);
        subtitle.lines.forEach(line =>
            {
                line.verticalPos = starty;
                starty+=2;
            }
        )

        ottosubtitles.subtitles.push(subtitle);
    })
    console.log(ottosubtitles)
    return ottosubtitles;

}




export function convertSTLtoOttoSubtitles(stldatas)
{
    var ottosubtitles = {};
    ottosubtitles.subtitles = [];
    ottosubtitles.params = configurations_getDefaultParams();

    if (stldatas.displaystandardcode !== "0") ottosubtitles.params.teletext = true;

    stldatas.subtitles.forEach ((subtitle,index) =>
    {
        var newst = {};
        newst.in = subtitle.in;
        newst.out = subtitle.out;
        newst.lines = [];
        //newst.numberOfLines = subtitle.lines.length;
        newst.mark = 0;
        for (var l=0; l< subtitle.lines.length; l++)
        {
            var line = {};
            line.len = 0;
            line.verticalPos = subtitle.lines[l].vertical_position;
            line.horizontalPos = subtitle.lines[l].horizontal_position;
            

            const color = colorcodeToHex(subtitle.lines[l].color_code);
            const text = subtitle.lines[l].text;
            const italic = subtitle.lines[l].italic;
            switch (subtitle.lines[l].alignment)
            {
                case "left":
                    line.align = 0;
                    break;
                case "right":
                    line.align = 1;
                    break;
                case "center":
                    line.align = 2
                    
                    break;
                case "unchanged":
                    line.align = 3;
                    break;
            }
            line.words = [];
            const words = text.trim().split(" ");
            for (var w=0; w < words.length;w++)
            {
                var word={};
                word.text = words[w];
                word.in = subtitle.in;
                word.out = subtitle.in;
                word.color = color;
                word.italic = italic;
                line.words.push(word);
            }

            newst.lines.push (line);


        }




        ottosubtitles.subtitles.push (newst);



    });

    return ottosubtitles;

}
